import Homepage from "./components/Homepage";
import "./App.css";
import { useScrollYPosition } from "react-use-scroll-position";
import Header from "./layout/Header";
import { memo, useState, useEffect, createContext } from "react";
import { useLocation } from "react-router-dom";

export const ChannelContext = createContext(null);

const App = () => {
  const scrollY = useScrollYPosition();
  const [channels, setChannels] = useState([]);
  const [playChannel, setPlayChannel] = useState(null);
  const [isVideoPageReload, setIsVideoPageReload] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if ("/" !== location.pathname) {
      const channel = sessionStorage.getItem("channel");
      setPlayChannel(JSON.parse(channel));
      setIsVideoPageReload(true);
      const channels = sessionStorage.getItem("channels");
      setChannels(JSON.parse(channels));
    } else {
      setPlayChannel(null);
      sessionStorage.removeItem("channel");
      sessionStorage.removeItem("channels");
      setIsVideoPageReload(false);
    }
  }, []);

  return (
    <>
      <div className="app">
        <ChannelContext.Provider
          value={{
            playChannel: playChannel,
            setPlayChannel: setPlayChannel,
            isVideoPageReload: isVideoPageReload,
            channels: channels,
            setChannels: setChannels,
          }}
        >
          <Header scrollY={scrollY} />
          <Homepage />
        </ChannelContext.Provider>
      </div>
    </>
  );
};

export default memo(App);
